import { useState } from "react";
import { Eye, EyeSlash } from "@phosphor-icons/react";

export default function PasswordInput({
  value,
  onChange,
  placeholder = "Password",
  required = false,
  autoFocus = false,
  testid,
  className = "w-full px-4 py-3 pr-11",
}) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative w-full">
      <input
        type={show ? "text" : "password"}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        autoFocus={autoFocus}
        data-testid={testid}
        className={className}
      />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        aria-label={show ? "Hide password" : "Show password"}
        data-testid={testid ? `${testid}-toggle` : "password-toggle"}
        className="absolute right-3 top-1/2 -translate-y-1/2 p-1"
        style={{ color: "var(--text-dim)", background: "transparent" }}
      >
        {show ? <EyeSlash size={16} weight="bold" /> : <Eye size={16} weight="bold" />}
      </button>
    </div>
  );
}
